export default "__VITE_PUBLIC_ASSET__a51b8a74__"